module.exports = __webpack_public_path__ + "img/near.be5030ca.webp";